export default __webpack_public_path__ + "static/media/qukes-miniroos-video.946d29fd.mp4";